import { NgModule } from '@angular/core';

import { AudioChannelCoreDataAccessModule } from '@shure/shared/angular/data-access/audio-channel-core';

import { CoverageAudioChannelApiService } from '../api/coverage-audio-channel-api.service';
import { CoverageAudioCoverageAreaApiService } from '../api/coverage-audio-coverage-area-api.service';
import { CoverageAudioPassiveSpeakerApiService } from '../api/coverage-audio-passive-speaker-api.service';
import { CoverageDeviceApiService } from '../api/coverage-device-api.service';
import { CoverageDeviceDebugApiService } from '../api/coverage-device-debug-api.service';

import { SysApiCoverageAudioChannelApiService } from './sys-api-coverage-audio-channel-api.service';
import { SysApiCoverageAudioCoverageAreaApiService } from './sys-api-coverage-audio-coverage-area-api.service';
import { SysApiCoverageAudioPassiveSpeakerApiService } from './sys-api-coverage-audio-passive-speaker-api.service';
import { SysApiCoverageDeviceApiService } from './sys-api-coverage-device-api.service';
import { SysApiCoverageDeviceDebugApiService } from './sys-api-coverage-device-debug-api.service';

@NgModule({
	imports: [AudioChannelCoreDataAccessModule],
	providers: [
		SysApiCoverageAudioChannelApiService,
		{
			provide: CoverageAudioChannelApiService,
			useExisting: SysApiCoverageAudioChannelApiService
		},
		SysApiCoverageAudioCoverageAreaApiService,
		{
			provide: CoverageAudioCoverageAreaApiService,
			useExisting: SysApiCoverageAudioCoverageAreaApiService
		},
		SysApiCoverageDeviceApiService,
		{
			provide: CoverageDeviceApiService,
			useExisting: SysApiCoverageDeviceApiService
		},
		SysApiCoverageDeviceDebugApiService,
		{
			provide: CoverageDeviceDebugApiService,
			useExisting: SysApiCoverageDeviceDebugApiService
		},
		SysApiCoverageAudioPassiveSpeakerApiService,
		{
			provide: CoverageAudioPassiveSpeakerApiService,
			useExisting: SysApiCoverageAudioPassiveSpeakerApiService
		}
	],
	exports: [AudioChannelCoreDataAccessModule]
})
export class SysApiCoverageDataAccessModule {}
